import { API_BASE_URL } from "../apiConfig";
import React, { useEffect, useState, useCallback } from "react";
import "./UserDashboard.css";

const UserDashboard = () => {
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState({
    totalComplaints: 0,
    completedComplaints: 0,
    pendingComplaints: 0
  });
  const [loading, setLoading] = useState(true);

  const fetchUserStats = useCallback(async () => {
    if (!user?.username) return;
    
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/complaint/user-stats/${user.username}`);
      if (!response.ok) {
        throw new Error("Failed to fetch stats");
      }
      const data = await response.json();
      setStats({
        totalComplaints: data.totalComplaints || 0,
        completedComplaints: data.completedComplaints || 0,
        pendingComplaints: data.pendingComplaints || 0
      });
    } catch (err) {
      console.error("Error fetching user stats:", err);
    } finally {
      setLoading(false);
    }
  }, [user?.username]);

  useEffect(() => {
    const syncUser = () => {
      // Prefer per-tab sessionStorage for current login
      const sessionStored = sessionStorage.getItem("currentUser");
      if (sessionStored) {
        try {
          const parsed = JSON.parse(sessionStored);
          if (parsed.role === "user") {
            setUser({ username: parsed.username, role: parsed.role });
            return;
          }
        } catch (e) {
          console.error("Failed to parse session user:", e);
        }
      }
      // Fallback to localStorage
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    };

    syncUser();
    window.addEventListener("storage", syncUser);
    window.addEventListener("focus", syncUser);

    return () => {
      window.removeEventListener("storage", syncUser);
      window.removeEventListener("focus", syncUser);
    };
  }, []);

  useEffect(() => {
    if (user?.username) {
      fetchUserStats();
    }
  }, [user?.username, fetchUserStats]);

  if (!user || loading) return <div className="user-dashboard loading"><div className="loading-spinner">Loading dashboard...</div></div>;

  return (
    <div className="user-dashboard">
      {/* HEADER */}
      <div className="dashboard-header">
        <div className="welcome">
          <h1>Welcome back, {user.username}! 👋</h1>
          <p>Here's your complaint summary.</p>
        </div>
      </div>

      {/* STATS */}
      <div className="stats-grid">
        <div className="stat-card total">
          <div className="icon">📋</div>
          <div>
            <h3>Total Complaints</h3>
            <h2>{stats.totalComplaints}</h2>
            <p>All your complaints</p>
          </div>
        </div>

        <div className="stat-card completed">
          <div className="icon">✅</div>
          <div>
            <h3>Completed</h3>
            <h2>{stats.completedComplaints}</h2>
            <p>Successfully resolved</p>
          </div>
        </div>

        <div className="stat-card pending">
          <div className="icon">⏳</div>
          <div>
            <h3>Pending</h3>
            <h2>{stats.pendingComplaints}</h2>
            <p>Awaiting resolution</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
